module.exports = __webpack_public_path__ + "static/media/card-unlocked-icon.8e85345e.svg";